module.exports = __webpack_public_path__ + "static/media/favicon-k.1a606028.ico";